export const campaigns = (type) => `/v2/guest/filter-campaigns/${type}`;
export const detailsDonation = (id) => `/v2/guest/campaigns/${id}`;
